import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import {
  Grid,
  defaultCellRangeRenderer,
} from 'react-virtualized'

import styles from './styles.scss'

class BodyGrid extends Component {
  static propTypes = {
    gridParams: PropTypes.object.isRequired,
    leftGridParams: PropTypes.object.isRequired,
    headerGridParams: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    getCache: PropTypes.func.isRequired,
    onScroll: PropTypes.func.isRequired,
    cellRenderer: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }

  componentDidMount() {
    if (this.props.register)
      this.props.register(this.grid)
  }

  componentWillUnmount() {
    if (this.props.unregister)
      this.props.unregister(this.grid)
  }

  setRef = (ref)  => this.grid = ref
  getContentHeight = () => this.props.height - this.props.headerGridParams.rowHeight
  getContentWidth = () => this.props.width

  onSectionRendered = (data) => {
    if (this.props.onSectionRendered)
      this.props.onSectionRendered(data)
  }

  cellRangeRenderer = (cellRangeProps) => {
    const {
      cellCache,                    // Temporary cell cache used while scrolling
      cellRenderer,                 // Cell renderer prop supplied to Grid
      columnSizeAndPositionManager, // @see CellSizeAndPositionManager,
      columnStartIndex,             // Index of first column (inclusive) to render
      columnStopIndex,              // Index of last column (inclusive) to render
      horizontalOffsetAdjustment,   // Horizontal pixel offset (required for scaling)
      isScrolling,                  // The Grid is currently being scrolled
      rowSizeAndPositionManager,    // @see CellSizeAndPositionManager,
      rowStartIndex,                // Index of first column (inclusive) to render
      rowStopIndex,                 // Index of last column (inclusive) to render
      scrollLeft,                   // Current horizontal scroll offset of Grid
      scrollTop,                    // Current vertical scroll offset of Grid
      styleCache,                   // Temporary style (size & position) cache used while scrolling
      verticalOffsetAdjustment,      // Vertical pixel offset (required for scaling)
      parent
    } = cellRangeProps
    let renderedCells = []

    for (let rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
      // This contains :offset (top) and :size (height) information for the cell
      let rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex)

      const style = {
        height: rowDatum.size,
        left: 0,
        right: 0,
        position: 'absolute',
        top: rowDatum.offset + verticalOffsetAdjustment - this.props.gridParams.rowHeight,
      }

      const rowColumnOffset = verticalOffsetAdjustment - rowDatum.offset
      renderedCells.push((
        <div
          class={styles.row}
          style={style}
          key={`Row${rowIndex}`}
        >
          {
            defaultCellRangeRenderer({
              ...cellRangeProps,
              verticalOffsetAdjustment: rowColumnOffset,
              rowStartIndex: rowIndex,
              rowStopIndex: rowIndex
            })
          }
        </div>
      ))
    }
    return renderedCells
  }

  render() {
    const {
      list,
      getCache,
      onScroll,
      cellRenderer,
      width,
      gridParams,
    } = this.props
    const {
      rowHeight,
      overscanColumnCount,
      overscanRowCount,
      estimatedColumnSize
    } = gridParams

    // skip header rows
    const rowCount = list.length
    const columnCount = list[0].length
    const cache = getCache()
    const height = this.getContentHeight()

    return (
      <div
        style={{
          height,
          width,
        }}
      >
        <Grid
          id='bodyGrid'
          ref={this.setRef}
          onSectionRendered={this.onSectionRendered}
          deferredMeasurementCache={cache}
          cellRangeRenderer={this.cellRangeRenderer}
          cellRenderer={cellRenderer}
          columnWidth={cache.columnWidth}
          columnCount={columnCount}
          height={height}
          overscanColumnCount={overscanColumnCount}
          overscanRowCount={overscanRowCount}
          rowHeight={rowHeight}
          rowCount={rowCount}
          onScroll={onScroll}
          estimatedColumnSize={estimatedColumnSize}
          styleName='bodyGrid'
          width={this.getContentWidth()}
        />
      </div>
    )
  }
}

export default CSSModules(styles, BodyGrid)
